var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.bemBlock }, [
    _c("h2", { class: _vm.bemElement("title") }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.customizerId === "designer"
              ? _vm.$msg("designer.main.selector.title", "customizer")
              : _vm.$msg("customizer.main.selector.title", "customizer")
          ) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.bemElement("products") },
      _vm._l(_vm.mainProducts, function(product, i) {
        return _c("TheProductCustomizerMain", {
          key: product.id + "-" + i,
          attrs: {
            product: product,
            reset: _vm.reset,
            "initially-selected": _vm.initialMainProductId === product.id
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }